import { render, staticRenderFns } from "./addcourse.vue?vue&type=template&id=44d36c94"
import script from "./addcourse.vue?vue&type=script&lang=js"
export * from "./addcourse.vue?vue&type=script&lang=js"
import style0 from "./addcourse.vue?vue&type=style&index=0&id=44d36c94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports